export default __webpack_public_path__ + "static/media/finance2.6e04f5d8.mp4";